import Vue from 'vue';
import Vuex from 'vuex';
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import SearchOptions from './modules/search-options';
import CustomerData from '../../used-vue/store/modules/customer-data';
import Dealers from '../../used-vue/store/modules/dealers';
import Auth from '../../core/modules/Auth/auth';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        SearchOptions,
        Dealers,
        CustomerData,
        Auth,
    }
});